import { graphql, useFragment } from 'react-relay';

import { type useRenderBlurbs_item$key } from './__generated__/useRenderBlurbs_item.graphql.ts';
import { type useRenderBlurbs_displayInfo$key } from './__generated__/useRenderBlurbs_displayInfo.graphql.ts';

const itemFragment = graphql`
    fragment useRenderBlurbs_item on Item {
        lastTransaction(buyerId: $userId) @include(if: $fetchUser) {
            checkoutDate
            isCanceled
            mostRecentOffer {
                isExpired
            }
        }
    }
`;

const displayInfoFragment = graphql`
    fragment useRenderBlurbs_displayInfo on ItemDisplayInfo {
        pricing {
            showSold
            showUnavailable
        }
    }
`;

export const useRenderBlurbs = ({
    item: itemRef,
    displayInfo: displayInfoRef,
}: {
    item: useRenderBlurbs_item$key | null | undefined;
    displayInfo: useRenderBlurbs_displayInfo$key | null | undefined;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);
    const displayInfo = useFragment(displayInfoFragment, displayInfoRef);

    if (!item || !displayInfo) {
        return false;
    }

    const pricingDisplayInfo = displayInfo?.pricing || null;
    const hasValidPricingDisplayInfo = !!pricingDisplayInfo && !pricingDisplayInfo.showUnavailable;

    const { lastTransaction } = item;
    const { checkoutDate, isCanceled, mostRecentOffer } = lastTransaction || {};
    const shouldRenderBlurbsForAuction = !!(
        lastTransaction &&
        !checkoutDate &&
        !mostRecentOffer?.isExpired &&
        !isCanceled
    );

    return (
        (hasValidPricingDisplayInfo && !pricingDisplayInfo.showSold) || shouldRenderBlurbsForAuction
    );
};
